export const list = (dispatch, apiClient) => apiClient
  .call({ endpoint: 'task/list' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data });
    return res;
  });

export const list2 = (dispatch, apiClient, query, ids, skipId) => apiClient
  .call({ endpoint: 'task/list2', data: { query, ...ids, skipId } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.results });
    return res;
  });


export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'task/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: [res.data.task, ...res.data.parents, ...res.data.children] });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'task/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, changes) => apiClient
  .call({ endpoint: 'task/update', data: { id, changes } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data });
    return res;
  });

export const newContainerPick = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'task/newContainerPick', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.task });
    return res;
  });

export const newContainerVerify = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'task/newContainerVerify', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.task });
    return res;
  });

export const newContainerShippingAdd = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'task/newContainerShippingAdd', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.task });
    return res;
  });

export const newContainerMove = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'task/newContainerMove', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.task });
    return res;
  });

export const newOrderPick = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'task/newOrderPick', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data.task });
    return res;
  });

export const taskDone = (dispatch, apiClient, id, comment) => apiClient
  .call({ endpoint: 'task/taskDone', data: { id, comment } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data });
    return res;
  });

export const taskSkip = (dispatch, apiClient, id, comment) => apiClient
  .call({ endpoint: 'task/taskSkip', data: { id, comment } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'TASK_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/tasks.js